import * as MuiIcons from "@mui/icons-material";
import * as Mui from '@mui/material';
import { Grid } from '@mui/material';
import { useEffect } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import FormTextField from "../../../experiments/forms/FormTextField";
import { usePaymentRequestRepository } from "../../../api/repositories/PaymentRequestRepository";
import { useRecoilState } from "recoil";
import { STATE_MODAL_UPDATING } from "./atoms/PaymentRequestAtoms";


interface Props {
  open: boolean;
  id: any;
  note: any;
  onClose: () => void;
}

const EditPaymentRequest = (props: Props) => {

  const { t } = useTranslation('finance', { keyPrefix: 'payments.payment-request' });
  const [updating, setUpdating] = useRecoilState(STATE_MODAL_UPDATING);
  const schema = Yup.object().shape({
    note: Yup.string().nullable().required(t('modal.required-error')).max(255),
  });

  const { putNoteById } = usePaymentRequestRepository();
  const { handleSubmit, control, setValue, trigger } = useForm<any>({
    defaultValues: {
      note: ""
    },
    resolver: yupResolver(schema),
  });


  async function renderNotes() {
    if (props?.note) {
      setValue('note', props.note);
      trigger('note');
    }
  }


  useEffect(() => {
    renderNotes();
  }, [props]);

  const onSubmit: SubmitHandler<any> = (data) => {
    putNoteById(props.id, data).then(() => {
      setUpdating(true);
      onClose();
    });
  }

  const onClose = () => {
    props.onClose();
  };

  return (
    <Mui.Dialog open={props.open} onClose={onClose} fullWidth maxWidth="md">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Mui.DialogTitle>
          <Mui.Grid container alignItems="center">
            <Mui.Grid item xs="auto">
              <Mui.Typography variant="h6">
                {t("modal.note-title")}
              </Mui.Typography>
            </Mui.Grid>
            <Mui.Grid item xs="auto" marginLeft="auto">
              <Mui.IconButton onClick={onClose}>
                <MuiIcons.Close />
              </Mui.IconButton>
            </Mui.Grid>
          </Mui.Grid>
        </Mui.DialogTitle>
        <Mui.DialogContent>
          <Grid container>

            <Grid item xs={12}>
              <FormTextField
                name={`note`}
                control={control}
                props={{
                  label: t('modal.note-content'),
                  fullWidth: true,
                  sx: { width: '100%' }
                }}
              />
            </Grid>

          </Grid>

        </Mui.DialogContent>
        <Mui.DialogActions>
          <Mui.Grid container justifyContent="end" spacing="16px">
            <Mui.Grid item xs="auto" height='48px'>
              <Mui.Button variant="outlined" size="medium" sx={{ maxWidth: '111px', minWidth: "111px", fontWeight: 700 }} onClick={onClose}>
                {t(
                  "modal.actionButtons.cancel"
                )}
              </Mui.Button>
            </Mui.Grid>
            <Mui.Grid item xs="auto">
              <Mui.Button type="submit" size="medium" sx={{ maxWidth: '111px', minWidth: "111px", fontWeight: 700 }} >
                {t("modal.actionButtons.save")}
              </Mui.Button>
            </Mui.Grid>
          </Mui.Grid>
        </Mui.DialogActions>

      </form>
    </Mui.Dialog>

  );
};

export default EditPaymentRequest;



